<ng-container *transloco="let t;">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h3 class="modal-title" id="sendSchemaDialogLabel">{{ t("schema.sendschema.title") }}</h3>
            </div>
            <div class="modal-body d-inline-flex align-items-center">
                <ng-container *ngIf="!isSchemaSentSucces() && !isSchemaSentError()">                                       
                    <p class="m-0">{{ t("schema.sendschema.text") }}</p>
                </ng-container>

                <ng-container *ngIf="isSchemaSentSucces()">
                    <svg class="icon-success icon-md b me-2">
                        <use xlink:href="assets/icons.svg#icon-circle-check"></use>
                    </svg>
                    <span>{{ t("schema.sendschema.successtext")}}</span>
                </ng-container>

                <ng-container *ngIf="isSchemaSentError()">
                    <svg class="icon-danger icon-lg b me-2">
                        <use xlink:href="assets/icons.svg#icon-circle-x"></use>
                    </svg>
                    <span>{{ t("schema.sendschema.errortext")}}</span>
                </ng-container>
            </div>
            <div class="modal-footer">
                <ng-container *ngIf="!isSchemaSending(); else loadingState">
                    <ng-container *ngIf="!isSchemaSentSucces() && !isSchemaSentError(); else closeDialogFooter">
                        <button class="btn wp-btn-outline" data-bs-dismiss="modal" (click)="onBack()">
                            {{ t("schema.sendschema.back") }}
                        </button>
                        <button class="btn wp-btn" type="submit" (click)="onSendSchema()">
                            <svg class="icon icon-dark-bg icon-sm me-2">
                                <use xlink:href="assets/icons.svg#icon-paper-plane"></use>
                            </svg>
                            {{ t("schema.sendschema.send")}}
                        </button>
                    </ng-container>

                </ng-container>
            </div>
        </div>
    </div>

    <ng-template #closeDialogFooter>
        <button class="btn wp-btn" data-bs-dismiss="modal" (click)="onDialogClose()">
            {{ t("schema.sendschema.close") }}
        </button>
    </ng-template>

    <ng-template #loadingState>
        <loading-spinner-border size="md" />
    </ng-template>

</ng-container>